export default __webpack_public_path__ + "static/media/satellite-67718_640.481927ab.jpg";